const nodeList = document.querySelectorAll("ul.sub_collections_nav li a");
for (let i = 0; i < nodeList.length; i++) {
  if((window.location.href).includes(nodeList[i].getAttribute('href'))){
    nodeList[i].closest('li').classList.add('active-sub-col-dk');
    // console.log('found');
  }
  
  // console.log(nodeList[i].getAttribute('href'));
}

const collapsable_list = document.querySelectorAll("details.dk_collapsible_product div.rte");
for (let index = 0; index < collapsable_list.length; index++) {
  let itemString = collapsable_list[index].innerHTML;
  // console.log(itemString.length);
  if(!itemString.length){
    collapsable_list[index].closest('.momdali_control_margin').style.display = 'none';
  }
  else{
    let childStringCheck = collapsable_list[index].querySelectorAll('.metafield-integer');
    if (childStringCheck.length) {
      for (let index2 = 0; index2 < childStringCheck.length; index2++) {
        // console.log();
        if (childStringCheck[index2].innerHTML.length<2) {
          collapsable_list[index].closest('.momdali_control_margin').style.display = 'none';
          break;
        }
      }
    }
  }
  
}

$(document).ready(function(){
    $('.dk_ul_slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      // prevArrow: $(this).siblings('.slider_controls_dk').find('.prev_arr_div_dk'),
      // nextArrow: $(this).siblings('.slider_controls_dk').find('.next_arr_div_dk'),
      // appendDots:$(this).siblings('.slider_controls_dk').find('.dots_div_dk'),
      adaptiveHeight: true,
      responsive: [{

        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: true
        }
  
      }, {
  
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          dots: true
        }
  
      }]
    });

  $('.darkknight_wrapper_main_collections').each(function(index,value) {
      let getHeight2 = $(this).children('.dk_list_collection_col_2').height();
      $(this).children('.dk_list_collection_col_1').css('max-height',`${getHeight2-35}px`);
  });

  $('.footer_logos_slider').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 3000,
      speed: 500,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: true
        }
  
      }, {
  
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          dots: true
        }
  
      }]
    });

  
  
  });